// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"36dbde63","315":"517d3b53","474":"5b1e63fb","500":"54e17249","524":"24c0d32a","647":"c2e29129","725":"d8b6078f","829":"98daed3b","881":"a38f3ea9","985":"59be02a1"}[chunkId] + ".chunk.js";
};